module.exports = __webpack_public_path__ + "static/media/PRO_DECK_SWITCH_PICTURE_1.7b595f3f.png";